import { Toaster as Sonner } from "sonner";

import { useAppTheme } from "@/hooks/useAppTheme";

type ToasterProps = React.ComponentProps<typeof Sonner>;

function Toaster({ ...props }: ToasterProps) {
  const theme = useAppTheme();
  // Mounted in __root outside any theme scope, so the token classes below
  // (bg-popover etc.) need the data-theme wrapper to resolve — same pattern
  // as the other portaled UI. Studio keeps its current dark rendering.
  return (
    <div
      data-theme={theme === "steward" ? "steward" : undefined}
      style={{ display: "contents" }}
    >
      <Sonner
        theme={theme === "steward" ? "light" : "dark"}
        className="toaster group"
        position="top-center"
        toastOptions={{
          duration: 2500,
          style: {
            fontSize: "14px",
          },
          classNames: {
            toast:
              "group rounded-2xl toast group-[.toaster]:bg-popover group-[.toaster]:text-popover-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg outline-none",
            description: "group-[.toast]:text-popover-foreground",
            actionButton:
              "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
            cancelButton:
              "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          },
        }}
        {...props}
      />
    </div>
  );
}

export { Toaster };
